export default __webpack_public_path__ + "static/media/DisabledDelete.e9b9bf3c.svg";